<div class="loading">
  <mat-spinner [strokeWidth]="4" [diameter]="24"></mat-spinner>
  <span *ngIf="!text">{{'general.loading'|translate}}...</span>
  <span *ngIf="text">{{text}}</span>
</div>